// extracted by mini-css-extract-plugin
export default {"entry":"iSmkJaHQeW","label":"ksqqi4yVAg"};